import {Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Performer } from 'src/app/store/performers.era';
import { SubmitEntityData } from 'globals/store/share.data';
import { ShareWrapper } from './share-wrapper.component';
import { CustomQuestion } from 'globals/store/events.data';
import { BrandingData, getJoiTemplate } from 'globals/store/publish.data';
import { CommonModule } from '@angular/common';
import { BrandingWrapperComponent } from 'src/app/components/branding/branding-wrapper.component';
import { PerformerEditProfileComponent } from './share.editPerformerForm.component';

@Component({
    selector: 'share-submit-performer',
    template: `
<branding-wrapper
  [brandingData]="brandingData" 
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'">
  <div *ngIf="loading" class="loading">Loading...</div>
  <div *ngIf="!loading && !performer" [innerHTML]="helpers.strWithBreak(inactiveUrlMessage)" class="sorry"></div>
  <div *ngIf="submitted"  class="thanks">
    Thank you! Your profile information has been submitted.
  </div>
  <share-edit-performer-form *ngIf="!!performer && !submitted"
    [topTitle]="(templateTitle || 'Call to Submit Performers') + ': ' + (eventName || 'Unnamed Event')"
    [eventId]="eventId"
    [performer]="performer"
    [instructions]="instructions"
    [publishCode]="templateId"
    [customQuestions]="customQuestions"
    [error]="error"
    [processing]="processing"
    [template]="template"
    [callToSubmit]="true"
    (onSubmit)="submit()">
  </share-edit-performer-form>
</branding-wrapper>


    `,
    styleUrls: ['./share.editPerformer.scss', './share-branding-wrapper.scss'],
    standalone: true,
    imports: [CommonModule, PerformerEditProfileComponent, BrandingWrapperComponent, ],
})
export class PerformerSubmitComponent extends ShareWrapper<PerformerSubmitComponent> {
  templateId: string
  eventId: string
  eventName: string
  templateTitle: string
  instructions: string

  cannotSubmitMessage = "A new performer profile can't be submitted at this time."
  performer:Performer
  inactiveUrlMessage = "This call for new performers is not currently available."
  customQuestions: CustomQuestion[] = []
  
  brandingData: BrandingData

  constructor(private route:ActivatedRoute) {
    super()
    this.loading = true;
    document.title = "loading";

    this.route.params.subscribe(params=>{
      const { eventId, templateId } = params;
      if (!eventId || !templateId) {
        this.loading = false;
        document.title = "Unavailable";
        return
      }

      this.templateId = templateId
      this.eventId = eventId
      const queryData: SubmitEntityData = { entityType: 'performer', submitTemplateId: templateId, eventId }
      this.publicService.loadSubmitEntityExtraData(queryData).then(data => {
        if (!data) {
          this.cannotLoad()
          return
        }
        const { eventTitle, customQuestions, templateTitle, instructions, brandingData } = data
        this.loading = false
        this.instructions = instructions
        this.brandingData = brandingData
        this.performer = {
          social: [],
          labels: [],
          customQuestions: {},
          name: '',
        }
        this.eventName = eventTitle
        this.templateTitle = templateTitle
        this.customQuestions = customQuestions
        this.template = brandingData?.template
        document.title = `Call for new performers`;
      }).catch(this.cannotLoad.bind(this))         
    })
  }

  cannotLoad(errorResponse = '') {
    if (errorResponse) console.error(errorResponse)
    this.loading = false
    this.showError(this.inactiveUrlMessage)
  }

  async submit() {
    const { templateId, eventId, performer } = this
    const submitData: SubmitEntityData = { entityType: 'performer', submitTemplateId: templateId, eventId, entity: performer }
    await this.submitEntity(submitData, this.cannotSubmitMessage)
  }
}

